import { SidebarStationService } from 'src/app/sidebar-station/sidebar-station.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import { FlatNode, Node } from './model/node.interface';
import { TabEnum } from '../station-management/components/model/tab.enum';

/**
 * data with nested structure.
 * Each node has a name and an optional list of children.
 */

@Component({
  selector: 'app-sidebar-station',
  templateUrl: './sidebar-station.component.html',
  styleUrls: ['./sidebar-station.component.scss'],
})
export class SidebarStationComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() listData: Node[];
  @Input() page: string;
  @ViewChild('tree') tree;

  treeControl: FlatTreeControl<FlatNode>;
  treeFlattener: MatTreeFlattener<any, any>;
  dataSource: MatTreeFlatDataSource<any, any>;
  showBadges: boolean;
  JSON: any;
  private transformer = (node: Node, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0 || node.expand,
      name: node.name,
      value: node,
      level,
    };
  };

  constructor(private readonly sidebarStationService: SidebarStationService) {
    this.treeControl = new FlatTreeControl<FlatNode>(
      (node) => node.level,
      (node) => node.expandable
    );

    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      (node) => node.level,
      (node) => node.expandable,
      (node) => node.children
    );

    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );

    this.JSON = JSON;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listData.currentValue.length) {
      this.dataSource.data = changes.listData.currentValue;
    }
  }

  ngOnInit(): void {
    this.showBadges = this.page === TabEnum.Station ? true : false;
    this.dataSource.data = this.listData;
  }
  hasChild = (_: number, node: FlatNode) => node.expandable;

  applySelectionItem(item: any) {
    this.sidebarStationService.applySelectionItem(item);
  }


  ngAfterViewInit(): void {
    this.listData.forEach((item) => {
      if (item.expand) {
        this.tree.treeControl.expand(this.treeControl.dataNodes[0]);
      }
    });
  }

}
